
import { ROUTES } from "@/router/constants";

export default {
  name: 'notFound',
  data() {
    return {
      ROUTES: ROUTES
    };
  }
}
